/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_2 = 'fragment-2',
  FRAGMENT_3 = 'fragment-3',
  FRAGMENT_4 = 'fragment-4',
  FRAGMENT_5 = 'fragment-5',
  FRAGMENT_6 = 'fragment-6',
  LAYOUT_ROOT = 'layout-root',
  ROUTE_APPLICATION = 'route-application',
  ROUTE_CONFIRMAR_USUARIO = 'route-confirmar-usuario',
  ROUTE_INACTIVITY = 'route-inactivity',
  ROUTE_LOGIN = 'route-login',
  ROUTE_NOVA_SENHA = 'route-nova-senha',
  ROUTE_RECUPERAR_SENHA = 'route-recuperar-senha',
  ROUTE_REDIRECT = 'route-redirect',
}
export { RootAliases };
